<template>
  <InfuseSlideInLayout
    :editable="true"
    :parent-to="{ name: 'user' }"
    :title="user?.email"
    :width-percentage="60"
    @edit="showUpdateUserModal = true"
  >
    <AssetLevelOverview :asset="user" />

    <InfuseRouterTabLayout :model="user" :is-loading="isLoading" />

    <MutationUserModal
      v-if="showUpdateUserModal"
      :loading="isUpdatingUser"
      :user="user"
      @close="closeUpdateModal"
      @update="onUpdateUser"
      :navigation-level="level"
    />
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { AssetLevelOverview } from '@infuse/iam/components';
import { useUpdateUser } from '@infuse/iam/user/mutations';
import { useUser } from '@infuse/iam/user/queries';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UpdateUser } from '@infuse/iam/user/type';
import { MutationUserModal } from '@infuse/iam/user/ui';
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { permissionOrRedirect } from '@infuse/ui/utils';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const { level } = useCurrentUserStore();
const { user, isLoading, fetchUserId } = useUser();

const showUpdateUserModal = ref(false);
const { mutateAsync: updateUser, isPending: isUpdatingUser } = useUpdateUser();

permissionOrRedirect();

watch(
  () => route.params.id,
  (id) => {
    fetchUserId.value = `${id}`;
  },
  { immediate: true }
);

async function onUpdateUser(vars: { id: string; user: UpdateUser }): Promise<void> {
  await updateUser(vars);
  closeUpdateModal();
}

function closeUpdateModal() {
  showUpdateUserModal.value = false;
}
</script>
